/**
 * Event name constants for tracking platforms
 */
export const EventNames = {
  // Page events
  PAGE_VIEWED: "Page Viewed",

  // Interaction events
  BUTTON_CLICKED: "Button Clicked",
  FORM_SUBMITTED: "Form Submitted",

  // Product events
  PRODUCT_VIEWED: "Product Viewed",
  ADDED_TO_CART: "Added To Cart",
  REMOVED_FROM_CART: "Removed From Cart",

  // Checkout events
  CHECKOUT_STARTED: "Checkout Started",
  PURCHASE_COMPLETED: "Purchase Completed",

  // Search events
  SEARCH: "Search",

  // User events
  USER_SIGNED_UP: "User Signed Up",
  USER_LOGGED_IN: "User Logged In",

  // MoEngage events
  ITEM_PURCHASED: "Item Purchased",
  UPDATE_CART: "Update Cart",
  CUSTOMER_REGISTERED: "Customer Registered",
  CUSTOMER_LOGGED_IN: "Customer Logged In",
  SHOPIFY_CHECKOUT_UPDATED: "Shopify - Checkout Updated",
  SHOPIFY_ABANDONED_CHECKOUT: "Shopify - Abandoned Checkout",
  SHOPIFY_ORDER_FULFILLED: "Shopify - Order Fulfilled",
  SHOPIFY_CHECKOUT_STARTED: "Shopify - Checkout Started",
  SHOPIFY_ADD_TO_CART: "Shopify - Add To Cart",
  SHOPIFY_REMOVED_FROM_CART: "Shopify - Removed From Cart",
  SHOPIFY_UPDATE_CART: "Shopify - Update Cart",
  SPINFORM_RESULT: "Spinform Result",
  COUPON_COPIED: "Coupon Copied",
  STARTED_CHECKOUT_GK: "Started Checkout GK",
  MOBILE_ADDED_GK: "Mobile Added GK",
  ADDRESS_SELECTED_GK: "Address Selected GK",
  ADDRESS_COMPLETED_GK: "Address Completed GK",
  PAYMENT_METHOD_SELECTED_GK: "Payment Method Selected GK",
  PAYMENT_COMPLETED_GK: "Payment Completed GK",
  ORDER_SUCCESS: "Order Success",
  ORDER_COMPLETED: "Order Completed",
  PIN_CODE_ADDED_GK: "PIN Code Added GK",
  ADDRESS_ADDED_GK: "Address Added GK",
  KP_MP_PHONE_NUMBER_LOGGED_IN: "KP MP Phone Number Logged In",
  KP_PHONE_NUMBER_LOGGED_IN: "KP Phone Number Logged In",
  KP_MP_SHOPIFY_LOGGED_IN: "KP MP Shopify Logged In",
  KP_MP_SUCCESSFULLY_LOGGED_OUT: "KP MP Successfully Logged Out",
  KP_WHATSAPP_LOGGED_IN: "KP Whatsapp Logged In",
  KP_MP_TRUECALLER_LOGGED_IN: "KP MP Truecaller Logged In",
  KP_MP_WHATSAPP_LOGGED_IN: "KP MP Whatsapp Logged In",
  KP_TRUECALLER_LOGGED_IN: "KP Truecaller Logged In",
  KP_SHOPIFY_LOGGED_IN: "KP Shopify Logged In",
  KP_SUCCESSFULLY_LOGGED_OUT: "KP Successfully Logged Out",
};

/**
 * Default currency code
 */
export const DEFAULT_CURRENCY = "INR";

export const HARDCODED_HANDLE = "ryze-gums";
